import { EMPTY_OBJECT } from '../../../constants/common'
import { EntityStatus } from '../../Entity'
import { useCalendarGridContext } from '../CalendarGrid.hooks'

function CalendarGridItemStatus({ className, item = EMPTY_OBJECT }) {
  const { ItemStatus } = useCalendarGridContext()

  const { status } = item

  return ItemStatus ? (
    <ItemStatus className={className} item={item} />
  ) : status ? (
    <EntityStatus
      className={className}
      id={status.id}
      statuses={status.statuses}
    />
  ) : null
}

export default CalendarGridItemStatus
